module.exports = __webpack_public_path__ + "static/img/bofang2.2388383a.png";